import { observer } from 'mobx-react-lite'
import { Alert, Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type ChooseNumberTabsStore } from 'entities/Phone/ui/ChooseNumberTabs/store/ChooseNumberTabsStore'
import { ChooseNumberTabs } from 'entities/Phone/ui/ChooseNumberTabs/ChooseNumberTabs'
import styles from './styles.module.scss'

type IGetNumberModalActionsProps = {
  store: ChooseNumberTabsStore
  showAlert: boolean
  editAnswersHandler?: () => void
}

export const GetNumberModalContent = observer(
  ({ store, showAlert, editAnswersHandler }: IGetNumberModalActionsProps) => {
    const editAnswers = () => {
      store.editAnswers()
      editAnswersHandler?.()
    }

    return (
      <div aria-label={getAriaLabel('GetNumberModalContent')}>
        {showAlert && (
          <Alert
            className={styles.alert}
            item={{
              type: 'success',
              desc: 'Great! Now let’s choose a number.',
            }}
          />
        )}
        <div
          className={styles.contentWrap}
          aria-label={getAriaLabel('GetNumberModalContent', 'contentWrap')}
        >
          <div className={styles.header}>
            <Typography variant={'heading-md'} ariaLabel='GetNumberModalContent_header'>
              Choose your number
            </Typography>
            <Typography
              variant={'body-md-regular'}
              ariaLabel='GetNumberModalContent_header_desc'
              color='var(--content-primary-tertiary'
              width={352}
            >
              You can always change this number later or replace with your existing number,
              landline, or Aircall number.
            </Typography>
          </div>

          <ChooseNumberTabs store={store} editAnswers={editAnswers} />
        </div>
      </div>
    )
  }
)
